module.exports = __webpack_public_path__ + "img/previewBill.3e561c4b.svg";